import React, { useContext, useEffect, useState } from 'react'
import { CCol, CFormSelect, CRow } from '@coreui/react'
// import './template.scss'
import { AppContext } from 'src/views/context/app'
import EditIcon from '../../../assets/edit-icon.svg'
import { formatBytes, getThumbnail } from 'src/views/utils/helper'
import { GlobalContext } from 'src/views/context/GlobalState'
import ImageNotFound from '../../../assets/image-not-found.jpg'
import { isEmpty } from 'lodash'

const FormAttachLink = ({ categoryData = [], linkData, setLinkData, disabled = false }) => {
  const { userSessionObj } = useContext(GlobalContext)
  const {
    setArtistModalProps,
    setVenueModalProps,
    setPageModalProps,
    setIptvModalProps,
    setContentModalNewProps,
    accountObj,
  } = useContext(AppContext)
  const [selectedEntity, setSelectedEntity] = useState('')
  const [selectedCategory, setSelectedCategory] = useState('')

  useEffect(() => {
    setSelectedEntity(linkData?.type)
    if (linkData?.type === 'CATEGORY' && !isEmpty(linkData?.data)) {
      setSelectedCategory(linkData?.data[0]?.id)
    }
  }, [linkData])

  const onSelectOptionChange = (value) => {
    setSelectedEntity(value)
    if (
      value === 'CONTENT_DETAIL' ||
      value === 'ARTIST_DETAIL' ||
      value === 'VENUE_DETAIL' ||
      value === 'PAGES' ||
      value === 'IPTV' ||
      value === 'CONTENT_DETAIL_PLAYER' ||
      value === 'PLAYER'
    ) {
      openModal(value)
    }

    setLinkData({ type: value, data: [] })
  }

  const openModal = (type, id = '') => {
    if (type === 'CONTENT_DETAIL' || type === 'CONTENT_DETAIL_PLAYER' || type === 'PLAYER') {
      setContentModalNewProps({
        type: 'multi',
        mappedContentId: id,
        mappedContentArray: [],
        selectCallback: (contentIds, contents) => {
          let data = []
          for (let i = 0; i < contents.length; i++) {
            const content = contents[i]

            let tempObj = {
              id: contentIds[i],
              title: content?.title,
              description: content?.description,
              thumbnail: content?.thumbnail?.website?.s3_key,
              other: [
                { name: 'Type', value: content?.video_type || '--' },
                { name: 'Category', value: content?.category[0]?.name },
                {
                  name: 'Size',
                  value: content?.source_asset
                    ? ['LIVE', 'MPVP'].includes(content?.video_type)
                      ? '-'
                      : formatBytes(content?.source_asset?.file_metadata?.file_size)
                    : '--',
                },
              ],
            }
            data.push(tempObj)
          }
          setLinkData({
            type: type,
            data: data,
          })
        },
      })
    }

    if (type === 'ARTIST_DETAIL') {
      setArtistModalProps({
        mappedArtistId: id,
        type: 'multi',
        selectCallback: (artistData) => {
          let data = []
          for (let i = 0; i < artistData.length; i++) {
            const artistObj = artistData[i]

            let tempObj = {
              id: artistObj._id,
              title: artistObj?.name,
              description: artistObj?.bio,
              thumbnail: artistObj?.poster?.s3_key,
              other: [
                {
                  name: 'Type',
                  value: artistObj?.artist_type,
                },
              ],
            }
            data.push(tempObj)
          }

          setLinkData({
            type: type,
            data: data,
          })
        },
      })
    }
    if (type === 'VENUE_DETAIL') {
      setVenueModalProps({
        mappedVenuetId: id,
        type: 'multi',
        selectCallback: (venueData) => {
          let data = []
          for (let i = 0; i < venueData.length; i++) {
            const venueObj = venueData[i]

            let tempObj = {
              id: venueObj._id,
              title: venueObj?.name,
              description: venueObj?.description,
              thumbnail: venueObj?.thumbnail?.s3_key,
              other: [
                {
                  name: 'Address',
                  value: venueObj?.address,
                },
              ],
            }
            data.push(tempObj)
          }

          setLinkData({
            type: type,
            data: data,
          })
        },
      })
    }
    if (type === 'PAGES') {
      setPageModalProps({
        mappedPageId: id,
        type: 'multi',
        selectCallback: (pageData) => {
          let data = []
          for (let i = 0; i < pageData.length; i++) {
            const pageObj = pageData[i]

            let tempObj = {
              id: pageObj._id,
              title: `Page Name : ${pageObj?.name}`,
              description:
                pageObj?.type === 'STATIC'
                  ? `Page URL : ${accountObj?.domain_name}/static${pageObj?.page_url}`
                  : `Page URL : ${accountObj?.domain_name}/custom${pageObj?.page_url}`,
              thumbnail: '',
              page_url:
                pageObj?.type === 'STATIC'
                  ? `/static${pageObj?.page_url}`
                  : `/custom${pageObj?.page_url}`,
              other: [],
            }
            data.push(tempObj)
          }

          setLinkData({
            type: type,
            data: data,
          })
        },
      })
    }
    if (type === 'IPTV') {
      setIptvModalProps({
        mappedChannelId: id,
        selectCallback: (channelObj) => {
          setLinkData({
            type: type,
            data: [
              {
                id: channelObj._id,
                title: channelObj?.name,
                description: channelObj?.description,
                thumbnail: channelObj?.thumbnail?.website?.s3_key,
                other: [],
              },
            ],
          })
        },
      })
    }
  }

  const onCategoryChange = (value) => {
    setSelectedCategory(value)
    let catObj = categoryData.find((info) => info._id === value)
    setLinkData({
      type: 'CATEGORY',
      data: [
        {
          id: value,
          name: catObj ? catObj?.name : '',
        },
      ],
    })
  }

  return (
    <>
      <CRow>
        <CCol>
          <CFormSelect
            placeholder="Select Entity"
            value={selectedEntity}
            onChange={(e) => onSelectOptionChange(e.target.value)}
            style={{ fontSize: '13px' }}
            disabled={disabled}
          >
            <option value="" selected disabled>
              Select Placement
            </option>
            <option value={'ARTIST_DETAIL'}>Artist Detail page</option>
            <option value={'ARTIST_LIST'}>Artist listing page</option>
            <option value={'CATEGORY'}>Category landing page</option>
            <option value={'PAGES'}>Pages</option>
            <option value={'CONTENT_DETAIL'}>Content Detail Page</option>
            <option value={'CONTENT_DETAIL_PLAYER'}>Content Detail Page & Player</option>
            <option value={'PLAYER'}>Only Player</option>
            <option value={'LOGIN'}>Log-in page</option>
            <option value={'REGISTER'}>Register Page</option>
            <option value={'HOME'}>Home Page</option>
            <option value={'IPTV'}>IPTV Channel</option>
            <option value={'ALL_IPTV'}>All IPTV Channels</option>
            <option value={'PRICING'}>Pricing Page</option>
            <option value={'VENUE_DETAIL'}>Venue Detail page</option>
            <option value={'VENUE_LIST'}>Venue listing page</option>
          </CFormSelect>
        </CCol>
      </CRow>

      {linkData?.type !== 'CATEGORY' && !isEmpty(linkData?.data) && (
        <div
          style={{ maxHeight: '160px', overflowY: 'scroll', overflowX: 'hidden' }}
          className="custom-scrollbar-vertical mt-2"
        >
          {linkData?.data.map((info, idx) => (
            <CRow className={`${idx && 'mt-2'}`} key={idx}>
              <CCol>
                <div className="attach-link-box flex position-relative">
                  {info.thumbnail && (
                    <img
                      src={getThumbnail(userSessionObj.session_data.cf_domain_name, info.thumbnail)}
                      alt="link img"
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null // prevents looping
                        currentTarget.src = ImageNotFound
                      }}
                    />
                  )}

                  <div
                    style={{ marginTop: '9px', width: '76%' }}
                    className="ml-4 mr-5 flex flex-column justify-content-between"
                  >
                    <span style={{ fontSize: '17px', fontWeight: 500 }} className="line-clamp-1">
                      {info.title}
                    </span>
                    <span
                      style={{
                        fontSize: '11.5px',
                        color: linkData?.type === 'PAGES' ? '#0073f6' : '',
                      }}
                      className="mt-1 line-clamp-2"
                    >
                      {info.description}
                    </span>
                    <span style={{ fontSize: '12px' }} className="mt-2 line-clamp-1">
                      {info.other.map((ele, index) => {
                        return ` ${index ? `\u00a0\u00a0` : ''} ${ele.name} : ${
                          ele.value
                        } \u00a0\u00a0 ${index < info?.other?.length - 1 ? ' | ' : ''}`
                      })}
                    </span>
                  </div>
                  <div className="position-absolute right-2">
                    <div
                      className=" h-[25px] w-[25px] rounded-full bg-[#20211c] flex justify-center items-center cursor-pointer"
                      style={{
                        boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)',
                        border: 'solid 0.5px #fff',
                      }}
                      onClick={() =>
                        openModal(
                          linkData.type,
                          linkData.type === 'IPTV'
                            ? info.id
                            : linkData?.data.map((info) => info.id),
                        )
                      }
                    >
                      <img
                        src={EditIcon}
                        style={{
                          width: '14px',
                          height: '14px',
                        }}
                        className=""
                        alt="editicon"
                      />
                    </div>
                  </div>
                </div>
              </CCol>
            </CRow>
          ))}
        </div>
      )}
      {linkData?.type === 'CATEGORY' && (
        <CFormSelect
          placeholder="Select Category"
          className="mt-3"
          value={selectedCategory}
          onChange={(e) => onCategoryChange(e.target.value)}
          style={{ fontSize: '13px' }}
          disabled={disabled}
        >
          <option value="" selected disabled>
            Choose Category
          </option>
          {categoryData.map((info) => (
            <option key={info._id} value={info._id}>
              {info.name}
            </option>
          ))}
        </CFormSelect>
      )}
    </>
  )
}

export default FormAttachLink
